import { useTranslation } from 'react-i18next';
import { BlankStateContainer } from '../styles/index.styles';

export const BlankState = () => {
  const { t } = useTranslation('common_terms');

  return (
    <BlankStateContainer>
      <p>{t('no_results')}</p>
    </BlankStateContainer>
  );
};
